import Swiper from 'swiper';
import { Autoplay, EffectCoverflow, Mousewheel, Navigation, Pagination, FreeMode, Thumbs, Keyboard } from 'swiper/modules';

import jsKit from './jsKit';

export const swipers = (() => {
  const defaults = {
    debugMode: false,
  };

  return {

    swiperProductCardInit: () => {
      if (!document.querySelector('#swiper-product-photos')) {
        return;
      };

      const swiperElThumbs = document.querySelector('#swiper-thumb-pagination');

      const swiperThumbs = new Swiper(swiperElThumbs, {
        modules: [Navigation, Mousewheel],
        spaceBetween: 16,
        breakpoints: {
          240: {
            slidesPerView: 3.5,
            spaceBetween: 8,
          },
          320: {
            slidesPerView: 4,
            spaceBetween: 8,
          },
          380: {
            slidesPerView: 4.5,
            spaceBetween: 8,
          },
          576: {
            slidesPerView: 4,
            spaceBetween: 8,
          },
          768: {
            slidesPerView: 4.5,
            spaceBetween: 8,
          },
          992: {
            slidesPerView: 5.5,
          },
          1200: {
            slidesPerView: 6.5,
          },
        },
        freeMode: true,
        mousewheel: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: swiperElThumbs.querySelector('[data-swiper-button-next]'),
          prevEl: swiperElThumbs.querySelector('[data-swiper-button-prev]'),
        },
      });

      const swiperEl = document.querySelector('#swiper-product-photos');

      const swiperProductsPhotos = new Swiper(swiperEl, {
        modules: [Thumbs, Navigation, Keyboard],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 10,
        thumbs: {
          slideThumbActiveClass: 'border-primary',
          autoScrollOffset: 1,
          swiper: swiperThumbs,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        navigation: {
          nextEl: swiperEl.querySelector('[data-swiper-button-next]'),
          prevEl: swiperEl.querySelector('[data-swiper-button-prev]'),
        },
      });

      const swiperModalProductsPhotos = new Swiper('#swiper-modal-product-photos', {
        modules: [Navigation, Keyboard],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 10,
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        navigation: {
          nextEl: '#swiper-modal-product-photos .swiper-button-next',
          prevEl: '#swiper-modal-product-photos .swiper-button-prev',
        },
      });

      if (!jsKit.isMobile() && (jsKit.rwdMedia.lg() || jsKit.rwdMedia.xl() || jsKit.rwdMedia.xxl())) {
        [...swiperEl.querySelectorAll('.swiper-slide')].forEach((el) => {
          el.addEventListener('click', (e) => swiperModalProductsPhotos.slideTo(parseInt(e.currentTarget.dataset.index, 10)));
        });
      }

      return {
        swiperProductsPhotos,
        swiperModalProductsPhotos,
      };
    },

    swiperGratisProductPhotosInit: (container = document) => {
      const swiperEl = container.querySelector('#swiper-gratis-product-photos');
      const paginationEl = container.querySelector('#swiper-gratis-thumb-pagination');

      if (!swiperEl || !paginationEl) {
        return;
      }

      return new Swiper(swiperEl, {
        modules: [Pagination],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: paginationEl,
          clickable: true,
          renderBullet: (index, className) => {
            const thumbs = Array.from(swiperEl.querySelectorAll('.swiper-slide')).map((el) => el.dataset.thumb);

            return `<span class="${className} mb-8"><img src="${thumbs[index]}" alt="" /></span>`;
          },
        },
      });
    },

    swiperLGInit: () => {
      if (!document.querySelector('#swiper-lg')) {
        return;
      }

      const swiperLG = document.querySelector('#swiper-lg');

      const swiperLGInstance = new Swiper(swiperLG, {
        init: false,
        modules: [Pagination, Autoplay, Navigation, FreeMode],
        direction: 'horizontal',
        loop: true,
        speed: 1200,
        watchOverflow: true,
        autoplay: {
          enabled: false,
        },
        breakpoints: {
          240: {
            slidesPerView: 1.4,
            spaceBetween: 16,
            freeMode: true,
          },
          576: {
            slidesPerView: 2.4,
            spaceBetween: 16,
            freeMode: true,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
            freeMode: false,
            autoplay: {
              enabled: true,
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            },
          },
        },
        pagination: {
          el: swiperLG.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: swiperLG.querySelector('[data-swiper-button-next]'),
          prevEl: swiperLG.querySelector('[data-swiper-button-prev]'),
        },
      });

      ['init', 'slideChange'].forEach((event) => swiperLGInstance.on(event, () => {
        if (jsKit.rwdMedia.xs() || jsKit.rwdMedia.sm()) {return;}
        swiperLG.querySelectorAll('.swiper-pagination-bullet').forEach((el) => {
          el.classList.remove('count-down');
          void el.offsetWidth;
        });
        const activeBullet = swiperLG.querySelector('.swiper-pagination-bullet-active');
        if (activeBullet) activeBullet.classList.add('count-down');
      }));

      swiperLGInstance.init();
    },

    swiperJumbotronInit: () => {
      if (!document.querySelector('.swiper-jumbotron')) {
        return;
      }

      [...document.querySelectorAll('.swiper-jumbotron')].forEach((elem) => {
        elem.swiperInstance = new Swiper(elem, {
          init: false,
          modules: [Pagination, Autoplay, Navigation],
          direction: 'horizontal',
          loop: true,
          speed: 1200,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          slidesPerView: 'auto',
          watchOverflow: true,
          pagination: {
            el: elem.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: elem.querySelector('[data-swiper-button-next]'),
            prevEl: elem.querySelector('[data-swiper-button-prev]'),
          },
        });

        ['init', 'slideChange'].forEach((event) => elem.swiperInstance.on(event, () => {
          elem.querySelectorAll('.swiper-pagination-bullet').forEach((el) => {
            el.classList.remove('count-down');
            void el.offsetWidth;
          });
          const activeBullet = elem.querySelector('.swiper-pagination-bullet-active');
          if (activeBullet) activeBullet.classList.add('count-down');
        }));

        elem.swiperInstance.init();
      });
    },

    swiperRCInit: () => {
      if (!document.querySelector('#swiper-rc')) {
        return;
      }

      new Swiper('#swiper-rc', {
        modules: [Pagination],
        direction: 'horizontal',
        slidesPerView: 'auto',
        watchOverflow: true,
        loop: true,
        pagination: {
          el: '#swiper-rc .swiper-pagination',
          clickable: true,
        },
      });
    },

    swiperBlogInit: () => {
      if (!document.querySelector('#swiper-blog')) {
        return;
      }

      new Swiper('#swiper-blog', {
        modules: [Pagination, Navigation],
        direction: 'horizontal',
        loop: true,
        slidesPerView: 'auto',
        watchOverflow: true,
        pagination: {
          el: '#swiper-blog .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '#swiper-blog .swiper-button-next',
          prevEl: '#swiper-blog .swiper-button-prev',
        },
      });
    },

    swiperWrappedInit: () => {
      if (!document.querySelector('#swiper-wrapped')) {
        return;
      }

      window.swiperWrapped = new Swiper('#swiper-wrapped', {
        init: false,
        modules: [Pagination, Navigation],
        direction: 'horizontal',
        loop: true,
        slidesPerView: 'auto',
        watchOverflow: true,
        pagination: {
          el: '#swiper-wrapped .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '#swiper-wrapped .swiper-button-next',
          prevEl: '#swiper-wrapped .swiper-button-prev',
        },
      });
    },

    topSaleInit: () => {
      if (!document.querySelectorAll('[data-top10]')) {
        return;
      }

      [...document.querySelectorAll('[data-top10]')].forEach((el) => {
        new Swiper(`#swiper-top10-${el.dataset.top10} .swiper`, {
          modules: [Pagination, Navigation, Mousewheel, FreeMode],
          direction: 'horizontal',
          watchOverflow: true,
          spaceBetween: 16,
          freeMode: true,
          breakpoints: {
            320: {
              slidesPerView: 1.2,
            },
            360: {
              slidesPerView: 1.4,
            },
            460: {
              slidesPerView: 1.8,
            },
            576: {
              slidesPerView: 2.1,
            },
            768: {
              slidesPerView: 2.3,
            },
            992: {
              slidesPerView: 2.5,
            },
            1200: {
              slidesPerView: 3.5,
            },
          },
          mousewheel: {
            forceToAxis: true,
          },
          pagination: {
            el: `#swiper-top10-${el.dataset.top10} .swiper-pagination`,
            clickable: true,
          },
          navigation: {
            nextEl: `#swiper-top10-${el.dataset.top10} [data-swiper-button-next]`,
            prevEl: `#swiper-top10-${el.dataset.top10} [data-swiper-button-prev]`,
          },
        });
      });
    },

    swiperTrustedUsInit: () => {
      if (!document.querySelector('#swiper-trusted-us')) {
        return;
      }

      new Swiper('#swiper-trusted-us', {
        modules: [Autoplay],
        loop: true,
        autoplay: {
          delay: 2000,
        },
        speed: 1000,
      });
    },

    swiperProducerInit: () => {
      if (!document.querySelector('#swiper-producer')) {
        return;
      }

      new Swiper('#swiper-producer', {
        modules: [Autoplay],
        direction: 'horizontal',
        slidesPerView: 'auto',
        watchOverflow: true,
        loop: true,
        autoplay: {
          delay: 2000,
        },
        speed: 1000,
      });
    },

    swiperAdvantagesInit: () => {
      if (!document.querySelector('#swiper-advantages')) {
        return;
      }

      new Swiper('#swiper-advantages', {
        modules: [Pagination],
        direction: 'horizontal',
        slidesPerView: 2,
        spaceBetween: 16,
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 24,
          }
        },
        speed: 1000,
        pagination: {
          el: '#swiper-advantages .swiper-pagination',
          clickable: true,
        },
      });
    },

    swiperEnthusiastsInit: () => {
      if (!document.querySelector('#swiper-enthusiasts')) {
        return;
      }
      const tabs = new Swiper('#tabs-enthusiasts', {
        modules: [FreeMode],
        spaceBetween: 0,
        slidesPerView: 'auto',
        breakpoints: {
          768: {
            spaceBetween: 32,
          },
        },
        freeMode: true,
        watchSlidesProgress: true,
      });

      new Swiper('#swiper-enthusiasts', {
        modules: [Pagination, EffectCoverflow, Thumbs],
        direction: 'horizontal',
        slidesPerView: 'auto',
        effect: 'coverflow',
        coverflowEffect: {
          depth: 0,
          modifier: 1,
          rotate: 0,
          scale: 0.75,
          slideShadows: false,
          stretch: 0,
        },
        speed: 1000,
        grabCursor: false,
        centeredSlides: true,
        thumbs: {
          swiper: tabs,
          slideThumbActiveClass: 'active',
        },
        pagination: {
          el: '#swiper-enthusiasts .swiper-pagination',
          clickable: true,
        },
        on: {
          // dotlottie-wc ustala rozdzielczość canvasu przy ładowaniu, gdy slajd jest pomniejszony przez coverflow
          slideChangeTransitionEnd: (swiper) => {
            swiper.slides[swiper.activeIndex]
              ?.querySelectorAll('dotlottie-wc')
              .forEach((player) => player.dotLottie?.resize());
          },
        },
      });
    },

    swiperOpinionsInit: () => {
      if (!document.querySelector('#swiper-opinions')) {
        return;
      }

      new Swiper('#swiper-opinions', {
        modules: [Pagination, EffectCoverflow],
        direction: 'horizontal',
        slidesPerView: 'auto',
        effect: 'coverflow',
        coverflowEffect: {
          depth: 0,
          modifier: 1,
          rotate: 0,
          scale: 0.65,
          slideShadows: false,
          stretch: 0,
        },
        loop: true,
        speed: 1000,
        grabCursor: false,
        centeredSlides: true,
        pagination: {
          el: '#swiper-opinions .swiper-pagination',
          clickable: true,
        },
      });
    },

    swiperRelatedProductsInit: () => {
      if (!document.querySelector('.swiper-product:not(.swiper-product-topSale)')) {
        return;
      }

      [...document.querySelectorAll('.swiper-product')].forEach((el) => {
        new Swiper(el, {
          modules: [Pagination],
          direction: 'horizontal',
          watchOverflow: true,
          spaceBetween: 16,
          breakpoints: {
            576: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          },
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
        });
      });
    },
  };
})();
